import React from 'react';
import { get } from 'lodash';
import { MuiGlobal } from './MuiGlobal';

export const MuiGlobalComponent = (path, Component) => (props) => {
	const { mui } = MuiGlobal.getAll();
	const RealComp = get(mui, `components.${path}`, Component);
	return <RealComp {...props} />;
};
